import type { AppModule } from '@dott/core';

import * as routes from './routes.js';

export const UsersModule: AppModule = {
  routes,
};
